import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

let loader;
const loadRzp = () => (loader ||= new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve(window.Razorpay);
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(window.Razorpay);
  s.onerror = () => { loader = null; reject(new Error("Couldn't load Razorpay checkout")); };
  document.body.appendChild(s);
}));

export async function openRazorpay(order) {
  const Rzp = await loadRzp();
  return new Promise((resolve, reject) => {
    const rzp = new Rzp({
      key: order.key_id, order_id: order.order_id, amount: order.amount, currency: order.currency, name: "Asterism Services", description: order.description || "Payment",
      ...(order.customer_id ? { customer_id: order.customer_id } : {}), ...(order.recurring ? { recurring: "1" } : {}),
      prefill: { name: order.name || "", email: order.email || "", contact: order.contact || "" }, theme: { color: "#0ea5e9" },
      handler: (res) => resolve(res), modal: { ondismiss: () => reject(new Error("dismissed")) },
    });
    rzp.on("payment.failed", () => {});
    rzp.open();
  });
}

export function RazorpayCardButton({ setupUrl, confirmUrl, consent, onSaved, className, children, testid = "rzp-card-btn" }) {
  const [busy, setBusy] = useState(false);
  const start = async () => {
    if (!consent) { toast.error("Please accept the auto-pay authorization first"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(setupUrl);
      const res = await openRazorpay(data);
      const { data: out } = await api.post(confirmUrl, { ...res, consent: true });
      toast.success("Card saved for auto pay"); onSaved?.(out);
    } catch (e) { if (e.message !== "dismissed") toast.error(e.response ? apiError(e.response.data?.detail) : e.message); }
    finally { setBusy(false); }
  };
  return <button type="button" onClick={start} disabled={busy} className={className} data-testid={testid}>{busy ? "Opening secure checkout…" : children}</button>;
}
